import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MeetingsRoutingModule } from './meetings-routing.module';
import { DeletedListingComponent } from './deleted-listing/deleted-listing.component';
import { OpportunitiesListingComponent } from './opportunities-listing/opportunities-listing.component';

@NgModule({
  declarations: [DeletedListingComponent, OpportunitiesListingComponent],
  imports: [CommonModule, MeetingsRoutingModule, SharedModule],
})
export class MeetingsModule {}
